import styled from 'styled-components';

export const ContentLabelsForm = styled.div`
  margin: 1em;
`;
